import React from "react";
import { TooltipContainer } from "../Tooltip.jsx";
import classNames from "classnames";
import { twClassNames } from "../../helpers/twClassNames.js";

export function FeatureGroup({ title, className }: { title?: string; className?: string }) {
    return (
        <span className={classNames("mt-2 text-sm font-semibold text-gray-900", className)}>
            {title}
        </span>
    );
}

type IconType = "included" | "downgrade" | "excluded" | "globe";
export function FeatureListing({
    boldText,
    text,
    iconType,
    downgradeAmount,
    exceededLimit,
    exceededLimitTooltip,
    excludeIcon,
    highlight
}: {
    boldText?: string;
    text?: string;
    iconType?: IconType;
    downgradeAmount?: string;
    exceededLimit?: boolean;
    exceededLimitTooltip?: any;
    excludeIcon?: boolean;
    highlight?: boolean;
}) {
    const iconMap = {
        included: "far fa-check text-brand",
        downgrade: "far fa-arrow-down text-gray-600",
        excluded: "fal fa-times text-gray-600",
        globe: "far fa-globe text-brand",
        support: "far fa-headset text-brand"
    };
    const iconClass = iconMap[iconType ?? "included"];
    return (
        <div
            className={classNames(
                "relative flex items-start gap-2 text-sm",
                highlight &&
                    "-ml-3 rounded-lg border border-yellow-300 bg-gradient-to-b from-white to-yellow-100 px-3 py-2 font-medium text-yellow-700"
            )}
        >
            {!excludeIcon && (
                <i
                    className={twClassNames(
                        "fa-fw flex-shrink-0 text-sm",
                        highlight ? "fas fa-star" : iconClass
                    )}
                ></i>
            )}
            <div className="flex flex-col gap-1">
                <span>
                    {boldText && <span className="font-semibold">{boldText + " "}</span>}
                    <span dangerouslySetInnerHTML={{ __html: text }}></span>
                </span>
                {exceededLimit && (
                    <div style={{ marginLeft: "-0.25rem" }}>
                        <TooltipContainer
                            type="error"
                            wide={false}
                            rightButton={<div>You've exceeded this limit</div>}
                            body={exceededLimitTooltip}
                        />
                    </div>
                )}
            </div>
            <span className="flex-grow"></span>
            {downgradeAmount && (
                <span className="whitespace-nowrap rounded-lg bg-red-50 px-2 py-0.5 text-sm font-medium text-red-600">
                    {downgradeAmount}
                </span>
            )}
        </div>
    );
}
